"use client";

import * as React from "react";
import { Pie, PieChart } from "recharts";

import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { cn, formatNumber } from "@/lib/utils";
import useScreenSize from "@/services/hooks/screen.hooks";

import { doughnutChartDataType } from "./PieChart";
import { Skeleton } from "../ui/skeleton";

export function DonutChart({
  data,
  config,
  isLoading,
  className,
  skeletonClassName,
  symbol,
}: {
  data: doughnutChartDataType[];
  isLoading: boolean;
  config: ChartConfig;
  className?: string;
  skeletonClassName?: string;
  symbol?: string;
}) {
  const { width } = useScreenSize();

  if (isLoading) {
    return (
      <Skeleton
        className={cn(
          skeletonClassName,
          "w-[78%] mx-auto h-full rounded-full aspect-square my-9",
        )}
      />
    );
  }

  return (
    <ChartContainer
      config={config}
      className={cn("mx-auto aspect-square", className)}
    >
      <PieChart>
        <ChartTooltip
          cursor={false}
          content={
            <ChartTooltipContent
              formatter={(value, name, item) => {
                const weight =
                  data.find((e) => e.coinSymbol === name && e.value === value)
                    ?.weight ?? 0;
                return (
                  <>
                    <div
                      className="w-3 h-3"
                      style={{
                        backgroundColor: item.payload.fill,
                      }}
                    />
                    {name.toString().toUpperCase()}{" "}
                    {formatNumber(
                      parseFloat(value.toString()),
                      true,
                      false,
                      1,
                      symbol ?? "$",
                    )}{" "}
                    {formatNumber(weight * 100)}
                    {"%"}
                  </>
                );
              }}
            />
          }
        />
        <Pie
          data={data}
          dataKey="value"
          nameKey="coinSymbol"
          innerRadius={width <= 450 ? 30 : 50}
          strokeWidth={10}
          paddingAngle={data.length > 1 && data.length < 5 ? 2 : 0}
        >
          {/* <Label
              content={({ viewBox }) => {
                if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                  return (
                    <text
                      x={viewBox.cx}
                      y={viewBox.cy}
                      textAnchor="middle"
                      dominantBaseline="middle"
                    >
                      <tspan
                        x={viewBox.cx}
                        y={viewBox.cy}
                        className="fill-foreground text-3xl font-bold"
                      >
                        {totalVisitors.toLocaleString()}
                      </tspan>
                      <tspan
                        x={viewBox.cx}
                        y={(viewBox.cy || 0) + 24}
                        className="fill-muted-foreground"
                      >
                        Visitors
                      </tspan>
                    </text>
                  );
                }
              }}
            /> */}
        </Pie>
      </PieChart>
    </ChartContainer>
  );
}
